export const TOP_TITLE = "Select dates";
export const BOTTOM_TITLE = "Select the distribution time";
export const BOTTOM_DESCRIPTION =
  "Set the time for the distributions. You can adjust the times individually once you have added the dates to the location.";

export const CLASSNAME_NEW_SELECTED_DATES = "react-datepicker__day--selected-new";
export const CLASSNAME_OLD_SELECTED_DATES = "react-datepicker__day--selected-old";

export const TIMELIST = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
